// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"6fae82eb","381":"066dbd1e","438":"ebf1ee2d","481":"6b7fb0b1","520":"f216cf9d","609":"662ee742","626":"3f3cdd09","845":"f829c274","933":"ba043fe6","961":"9d16cc4b","984":"c241b90e"}[chunkId] + ".chunk.js";
};